import { Box, Pagination } from 'braid-design-system';
import type React from 'react';

import { PER_PAGE } from 'src/App/constants/filter';
import { useQueryParam } from 'src/hooks/useQueryParam';

import { RedirectToFirstPage } from '../RedirectToFirstPage/RedirectToFirstPage';

interface PaginationSectionProps {
  totalCount: number;
}

export const PaginationSection: React.FC<
  React.PropsWithChildren<PaginationSectionProps>
> = ({ totalCount }) => {
  const { page, setPage } = useQueryParam();
  const totalPage = Math.ceil(totalCount / PER_PAGE);

  if (page > totalPage) {
    return <RedirectToFirstPage />;
  }

  if (totalPage === 1) {
    return null;
  }

  return (
    <Box background="surface" padding="small">
      <Pagination
        page={page}
        total={totalPage}
        linkProps={({ page: newPage }) => ({
          href: '#',
          onClick: (e) => {
            e.preventDefault();
            setPage(newPage);
            window.scrollTo(0, 0);
          },
        })}
        label="Jobs list pagination"
      />
    </Box>
  );
};
